export enum EncryptionType {
  HEADER = 'HEADER',
  DATA = 'Data',
}

import { Injectable } from '@angular/core';
// import AES from 'crypto-js/aes';
// import ENC from 'crypto-js/enc-base64';
import CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  iv = CryptoJS.enc.Base64.parse(environment.iv);
  key = CryptoJS.SHA256(environment.key);
  secretKey = environment.key;
  encryptedString: any;
  
  encrypt(data: any,type:string): any {
    this.encryptedString = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      this.key,
      {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    if(type===EncryptionType.HEADER){
      return this.encryptedString.toString();
    }else{
      return {
      hash: this.encryptedString.toString(),
    };
    }
  }

  decryptData(encrypted: any): any {
    const decrypted = CryptoJS.AES.decrypt(encrypted, this.secretKey, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  encryptLocalStorage(data: any, key: string): any {
    let encyrpted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      this.secretKey
    ).toString();
    localStorage.setItem(key, encyrpted);
  }
  
  decryptLocalStorage(key: string): any {
    if (key) {
      const data = localStorage.getItem(key);
      if (data) {
        const bytes = CryptoJS.AES.decrypt(data, this.secretKey);
        const recieved = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(recieved);
      }
    }
  }
}